import { cn } from '@/lib/utils';

export const MaybeTabs = ({
  hasAvailableProduct,
  currentFabricArrayShowTabs,
  fabricLabel,
  currentProduct,
  setCurrentProduct,
  colorNumber,
  configurableColorNumber,
  className,
}: {
  hasAvailableProduct: boolean;
  currentFabricArrayShowTabs: string[] | undefined;
  fabricLabel: string;
  currentProduct: string;
  setCurrentProduct: (product: 'product' | 'available_product') => void;
  colorNumber: number | undefined;
  configurableColorNumber: number | undefined;
  className?: string;
}) => {
  if (!hasAvailableProduct || configurableColorNumber === 0) {
    return null;
  }

  if (currentFabricArrayShowTabs && !currentFabricArrayShowTabs.includes(fabricLabel)) {
    return null;
  }

  return (
    <div className={cn('flex gap-5 border-b-1 border-solid border-[#E7DED5]', className)}>
      <button
        type='button'
        className={cn(
          'duration-300 border-b-[4px] border-solid border-transparent capitalize leading-[50px] transition-all',
          currentProduct === 'product' ? 'border-[#BE9983] font-bold' : 'border-transparent',
        )}
        onClick={() => {
          const url = new URL(window.location.href);

          url.searchParams.delete('in-stock');
          window.history.replaceState({ isProductOption: true }, '', url);
          setCurrentProduct('product');
        }}
      >
        all({colorNumber || ''})
      </button>
      <button
        type='button'
        className={cn(
          'duration-300 border-b-[4px] border-solid border-transparent capitalize leading-[50px] transition-all',
          currentProduct === 'available_product' ? 'border-[#BE9983] font-bold' : 'border-transparent',
        )}
        onClick={() => setCurrentProduct('available_product')}
      >
        ⚡ Ready to Ship
      </button>
    </div>
  );
};
